import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import AHDate from "_shared/dates/date";
import { z } from "zod";

export type DateParams = z.infer<typeof DateSchema.DateZ>;
export type DateJSON = z.infer<typeof DateSchema.DateJSONZ>;

export default class DateSchema {
  public static readonly type = z.custom<AHDate>((value) => value instanceof AHDate && value.isValid, {
    message: "Invalid Date",
  });

  public static DateJSONZ = z.iso.datetime({ offset: true });
  public static DateZ = z.iso.datetime({ offset: true });

  public static serialize(date: DateParams): string {
    return DateSchema.codec.encode(date);
  }

  public static deserialize(dateString: unknown): DateParams {
    return parseOrThrow(DateSchema.DateZ, dateString, {
      logError: true,
      schemaName: "DateSchema",
      operation: "deserialize",
      payloadSample: dateString,
    });
  }

  private static readonly codec = z.codec(DateSchema.DateJSONZ, this.DateZ, {
    decode: (dateString) => z.iso.datetime({ offset: true }).parse(dateString),
    encode: (dateString) => z.iso.datetime({ offset: true }).parse(dateString),
  });
}
